/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiBucketGroupPayloadFromJSON, ApiBucketGroupPayloadToJSON, } from './ApiBucketGroupPayload';
export function ApiBucketPayloadFromJSON(json) {
    return ApiBucketPayloadFromJSONTyped(json, false);
}
export function ApiBucketPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attributionTags': !exists(json, 'attributionTags') ? undefined : json['attributionTags'],
        'groups': !exists(json, 'groups') ? undefined : (json['groups'].map(ApiBucketGroupPayloadFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function ApiBucketPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attributionTags': value.attributionTags,
        'groups': value.groups === undefined ? undefined : (value.groups.map(ApiBucketGroupPayloadToJSON)),
        'name': value.name,
    };
}
